<template>
  <v-row no-gutters class="main-content">
    <top-navbar></top-navbar>
    <data-manager></data-manager>
    <v-col>
      <side-menu-bar v-if="currentMission != null"></side-menu-bar>
      <v-main>
        <router-view></router-view>
      </v-main>
    </v-col>
  </v-row>
</template>

<script>
import SideMenuBar from '../layout/SideBar.vue'
import TopNavbar from '../layout/TopNavBar.vue'
import DataManager from '../layout/DataManager.vue'
import { mapGetters, mapActions } from 'vuex'
import logHandler from '../mixins/logHandler'

export default {
  name: 'application-layout',
  components: { SideMenuBar, TopNavbar, DataManager },

  mixins: [logHandler],

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission'
    })
  },

  data() {
    return {
      maintenanceStatusInterval: null
    }
  },

  mounted: async function () {
    await this.loadOptions()
    this.$root.$emit('user-options-data-loaded')

    this.$root.$on('base-object-updated', this.baseObjectUpdatedHandler)
    this.$root.$on('delete-mission', this.deleteMissionHandler)
    await this.loadUserSettings()
    this.$root.$emit('user-settings-data-loaded')

    await this.loadUserGroups()
    this.checkCurrentMissionLoaded()
    this.maintenanceStatusInterval = setInterval(
      function () {
        this.$http.get('/users/maintenanceStatus').then((response) => {
          if (response.data === true) {
            this.$router.push('/maintenance')
          } else {
            if (this.$route.path === '/maintenance') {
              this.$router.push('/missions')
            }
          }
        })
      }.bind(this),
      60000
    )
  },

  beforeDestroy() {
    this.$root.$off('base-object-updated', this.baseObjectUpdatedHandler)
    this.$root.$off('delete-mission', this.deleteMissionHandler)
  },

  methods: {
    ...mapActions([
      'setCurrentMission',
      'loadUserGroups',
      'loadUserSettings',
      'loadOptions'
    ]),

    baseObjectUpdatedHandler() {
      // to update dirty state flag
      this.reloadCurrentMission()
    },
    deleteMissionHandler(missionId) {
      this.missionDeleted(missionId)
    },

    reloadCurrentMission() {
      if (this.currentMission != null) {
        let typeName = localStorage.currentMissionId.split('|')[0]
        let id = localStorage.currentMissionId.split('|')[1]
        this.$http
          .get(this.getMissionAPI(typeName) + '/' + id)
          .then((response) => {
            this.setCurrentMission(response.data)
          })
          .catch((e) => {
            // mission does not exist anymore or is owned by another user
            localStorage.currentMissionId = null
            this.displayMessage(
              'Failed to load mission.',
              e,
              'notification',
              'error'
            )
          })
      }
    },

    checkCurrentMissionLoaded() {
      if (
        localStorage.currentMissionId != null &&
        this.currentMission == null
      ) {
        // TODO we should check the format is respected
        let typeName = localStorage.currentMissionId.split('|')[0]
        let id = localStorage.currentMissionId.split('|')[1]
        if (id) {
          this.$http
            .get(this.getMissionAPI(typeName) + '/' + id)
            .then((response) => {
              this.setCurrentMission(response.data)
            })
            .catch((e) => {
              // mission does not exist anymore or is owned by another user
              localStorage.currentMissionId = null
              this.displayMessage(
                'Failed to load mission.',
                e,
                'notification',
                'error'
              )
            })
        }
      }
    },

    missionDeleted(missionId) {
      if (this.currentMission != null && this.currentMission.id === missionId) {
        this.setCurrentMission(null)
        this.$router.push({ path: '/missions' })
      }
    },

    // TODO this method is copied from forms, it should be but in tool file like data.js. also copied in mission.vue
    getMissionAPI(typeName) {
      return this.getAPI(typeName + 's')
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    }
  }
}
</script>

<style scoped>
.main-content {
  display: contents;
}
</style>
<style>
/* align the checkbox */
label.v-label.theme--light {
  margin-bottom: 0px;
}

.descriptionPlaceholder.theme--light.v-input input::placeholder {
  color: dimgrey !important;
  opacity: 1; /* Firefox */
}

.descriptionPlaceholder.theme--light.v-input input::-webkit-input-placeholder {
  color: dimgrey !important;
  opacity: 1; /* Firefox */
}

.descriptionPlaceholder.theme--light.v-input input:-moz-placeholder {
  color: dimgrey !important;
  opacity: 1; /* Firefox */
}

.descriptionPlaceholder.theme--light.v-input input::-moz-placeholder {
  color: dimgrey !important;
  opacity: 1; /* Firefox */
}

.descriptionPlaceholder.theme--light.v-input input::-ms-input-placeholder {
  color: dimgrey !important;
  opacity: 1; /* Firefox */
}

.descriptionPlaceholder.theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.7);
}
.descriptionPlaceholder.v-text-field input {
  padding: 0px;
}
</style>
